import React, { useEffect, useState } from "react";
import TableSkeleton from "../../atoms/TableSkeleton";
import classes from "./Table.module.css";
import { mergeClass } from "../../../resources/utils/helper";
import NoData from "../../molecules/NoData/NoData";
import { recordsLimit } from "../../../developmentContent/app-data";
import PaginationComponent from "../../molecules/PaginationComponent/index";
export default function Table({
  headings,
  tableData,
  loading = false,
  id,
  tableHead,
  custTableClass,
  tableBodyClass,
  isModal = false,
  showNoteInput,
  addNote,
  tableHeaderDiv,

  children,
  hasPagination = true,
  ...props
}) {
  return (
    <div
      className={mergeClass(
        "table100 ver1 m-b-110",
        classes.rootHeaderStyle,
        tableHeaderDiv
      )}
    >
      <style>{`
  .table100-body {
    overflow-y: scroll;
  }
  .table200-body {
    overflow-y: scroll;
  }

  @media screen and (max-width: 1440px) {
    {/* .table100-head, .table100-body {
      width: 1200px;
    } */}

    {/* .table100-head, .table200-body {
      width: 1200px;
    } */}
    .table100.ver1 {
      overflow-x: scroll;
    }
    .loading {
      overflow-x: hidden !important;
    }
  }
`}</style>

      <div
        className={mergeClass(classes.tableHeader, tableHead, "table100-head")}
      >
        <table className={classes.table}>
          <thead className={mergeClass(classes.tableHeaderStyle)}>
            <tr className={mergeClass(classes.border_radius)}>
              {headings?.map((item, index) => (
                <th
                  key={`${item?.label}${index}`}
                  className={mergeClass(
                    "fs-20",
                    classes.headings,
                    item?.className
                  )}
                  style={{
                    textAlign: "start",
                    ...(item?.style ?? {}),
                  }}
                >
                  {item.label}
                </th>
              ))}
            </tr>
          </thead>
        </table>
      </div>
      {loading ? (
        <TableSkeleton rowsCount={recordsLimit} colsCount={5} />
      ) : (
        <div
          className={mergeClass(
            classes.tableBody,
            tableBodyClass,
            `table100-body`
          )}
        >
          <table className={mergeClass(classes.customTableCss, custTableClass)}>
            <tbody>
              {tableData?.length > 0 ? (
                tableData?.map((item, index) => (
                  <React.Fragment key={item?._id || item?.id || index}>
                    <tr
                      className={mergeClass(
                        classes.border_radius,
                        !addNote && classes.borderBottom
                      )}
                    >
                      {headings?.map((a) => (
                        <td
                          className={""}
                          key={a?.id + "" + index}
                          style={{
                            textAlign: "start",
                            ...(a?.style ?? {}),
                          }}
                        >
                          <div
                            className="maxLine1 mx-2"
                            style={{ ...(a?.bodyStyle ?? {}) }}
                          >
                            {a?.renderValue
                              ? a?.renderValue(item, index)
                              : item?.[a?.id]}
                          </div>
                        </td>
                      ))}
                    </tr>
                    {showNoteInput === index && children}
                  </React.Fragment>
                ))
              ) : (
                <div className={classes.noData}>
                  <NoData />
                </div>
              )}
            </tbody>
          </table>
        </div>
      )}
      <div className="flex justify-center mt-2">
        {hasPagination && <PaginationComponent {...props} />}
      </div>
    </div>
  );
}
